import { useFind, usePopulate } from 'api/APIHooks';
import { useCurrentProviderId } from 'common/contexts/CurrentProviderContext';

/**
 * Shared hook to build assignee options for workqueues
 * - Fetches active employees for the current provider
 * - Optionally filters by one or more role keys
 */
export const useWorkqueueEmployees = (role = '', enabled = true) => {
  const providerId = useCurrentProviderId();

  const filterParams = {
    provider: providerId,
    state: 'active',
  };

  if (role) {
    filterParams['roles.key'] = role;
  }

  const { data: employeesResponse } = useFind(
    'employee',
    filterParams,
    {
      queryConfig: {
        placeholderData: undefined,
        enabled: !!providerId && enabled,
      },
      page: { size: Infinity },
      sort: 'first_name,last_name',
    },
  );

  const employees = employeesResponse?.data?.data ?? [];

  usePopulate('roles', 'role', employees, {
    queryConfig: {
      placeholderData: undefined,
      enabled: employees.length > 0,
    },
  });

  return employees;
};
